export default {"src":"/_next/static/media/hero_image.effd16f0.svg","height":596,"width":1440};